// Accordion titles for LVGL parts whose schema doesn't yet declare its own
// `label` metadata (see v2/objects/dropdown.js for the reference implementation).
// Shared by PropertiesPanel.vue (generic part accordions) and StatesPanel.vue
// (per-state part sub-sections) so both label parts identically.
export const DEFAULT_PART_LABELS = {
    items:         'items',
    item_buttons:  'item buttons',
    selected:      'item selected',
    major_ticks:   'major ticks',
    text_cursor:   'text cursor',
    scrollbar:     'scrollbar',
    special:       'specials',
};

/** Display label for a part — schema `label` metadata wins, then the fallback table above, then the raw part name. */
export function partLabel(node, partName) {
    const partDef = node?.getStyleDefinition(partName);
    return partDef?.label ?? DEFAULT_PART_LABELS[partName] ?? partName.replace(/_/g, ' ');
}
